<template>
  <div class="comp-training">
    <div class="left">
      <router-link :to="`${$subsitePrefix}/innovation/league-detail/${data.Id}`" :target="target">
        <img @error="imgError" :src="data.Illustration" :alt="data.Name" />
      </router-link>
    </div>
    <div class="right">
      <h3 class="name">
        <router-link :to="`${$subsitePrefix}/innovation/league-detail/${data.Id}`" :target="target">
          {{ data.Name }}
        </router-link>
      </h3>
      <!-- <p class="desc">
        <span>报名时间：{{ `${data.RegistStartTime} ~ ${data.RegistEndTime}` }}
        </span>
        <span>培训时间：{{ `${data.StartTime} ~ ${data.EndTime}` }}</span>
      </p>
      <p class="desc">
        <span>培训地址：{{ data.Description }}</span>
      </p>
      <p class="link">
        <router-link :to="'/feature/ss/society/training/detail/' + data.Id" :target="target">查看详细</router-link>
        <span class="stat">计划培训{{ data.RecruitersQty }}人</span>
      </p> -->
      <p class="link">
        <router-link :to="`${$subsitePrefix}/innovation/league-detail/${data.Id}`" :target="target">查看详细</router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "training-card",
  props: {
    data: {
      type: Object
    },
    target: {
      type: String,
      default: "_self"
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-training {
  display: flex;
  .left {
    width: 210px;
    height: 149px;
    border-radius: 8px;
    overflow: hidden;
    &:hover {
      box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.5);
      border-radius: 8px;
    }
  }
  .right {
    flex: 1;
    margin-left: 24px;
  }
  .name {
    padding: 0 0 14px 0;
    font-size: 20px;
    font-weight: 500;
    max-width: 750px;
    @include ellipsis();
  }
  .desc {
    color: #999;
    line-height: 22px;
    padding-bottom: 8px;
    span {
      padding-right: 50px;
    }
  }
  .link {
    padding-top: 10px;
    a {
      width: 88px;
      height: 32px;
      line-height: 32px;
      border-radius: 20px;
      border: 1px solid $primary-color;
      display: inline-block;
      text-align: center;
      color: $primary-color;
      &:hover {
        background-color: $primary-color;
        border-color: $primary-color;
        color: #fff;
      }
    }
    .stat {
      padding-left: 10px;
      color: #999;
    }
  }
}
</style>
